import { FIELDS, PREFIX } from '../const/training';
import reduce, { getFieldsByName } from '../util/baseReducer';

const initialState = {
  loading: false,
  saving: false,
  initialized: false,
  trainingClassDataset: [],
  trainingClassCurrentEntry: {},
  trainingAttendeeDataset: [],
  trainingAttendeeCurrentEntry: {},
};

const FIELDS_BY_NAME = getFieldsByName(FIELDS);

export default function trainingReducer(state = initialState, action) {
  const newState = {};
  reduce(action, state, newState, PREFIX, FIELDS_BY_NAME);
  return Object.assign({}, state, newState);
}
